import * as PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { trackLinkClick } from '../../analytics';
import translate from '../../functions/translate';
import the from '../../objects/the';
import Div from '../div';
import InputField from '../input.field';

const UserNameSection = props => {
   return <>
      <Div isRow={true}>
         <Div cols={11} colsSM={10} colsMD={9} colsLG={6} colsXL={5}>
            <InputField
               aria-invalid={(!!props.errorMessage).toString()}
               errorMessage={props.errorMessage}
               id={'username-textbox'}
               inputRef={props.inputRef}
               label={translate('Username')}
               name={translate('Username')}
               onBlur={props.onBlur}
               onChange={props.onChange}
               style={{minWidth: '100%'}}
               onFocus={props.onFocus}
               value={props.value}
            />
            <Div isRow={true}>
               <Div cols={12}>
                  <Div marginTop={0}>
                     <Div>
                        <Link style={{
                           color: the.color.tarheelBlue
                        }}
                           onClick={trackLinkClick}
                           to="/forgot-username"
                        >{translate('Forgot username?')}</Link>
                     </Div>
                  </Div>
               </Div>
            </Div>
         </Div>
      </Div>
   </>;
};

UserNameSection.propTypes = {
   onChange: PropTypes.func,
   onBlur: PropTypes.func,
   value: PropTypes.string,
   label: PropTypes.string,
   errorMessage: PropTypes.string,
   inputRef: PropTypes.func,
   onFocus: PropTypes.func
};

export default UserNameSection;